import React, { Component } from "react";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import axios from "axios";
import swalt from "@sweetalert/with-react";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getTransactionHistory } from "../../actions/usersAction";
import Wrapper from "../../Components/Container";

import Spinner from "../../Components/Spinner";

import styles from "./../Transfer/style.module.scss";

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            networkProvider: "",
            tvPlan: "",
            cardNumber: "",
            user: "",
            waiting: false,
            validated: false,
            validating: false,
            userBalance: 0,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    validate = () => {
        if (
            !this.state.networkProvider ||
            !this.state.cardNumber ||
            this.state.cardNumber.length !== 10
        ) {
            return swalt("Verification Failed", "Invalid Details", "error");
        }

        let data = {
            accountNumber: this.state.cardNumber,
            bankCode: this.state.networkProvider,
        };

        const token = Cookies.get("_lab__topup");
        const api = `${process.env.REACT_APP_BACKEND_URI}/verifyBankAccount`;

        this.setState({ validating: true });

        axios
            .post(api, data, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                // console.log(res.data);
                if (!res.data.status) {
                    swalt("Wrong Data", "Invalid Details", "error");
                    return this.setState({ validating: false });
                } else {
                    return this.setState({
                        validating: false,
                        user: res.data.data.account_name,
                        validated: true,
                    });
                }
            })
            .catch((err) => {
                return this.setState({ validating: false });
            });
    };

    onSubmit(e) {
        e.preventDefault();

        const data = {
            name: this.state.user,
            bank_code: this.state.networkProvider,
            account_number: this.state.cardNumber,
        };
        const api = `${process.env.REACT_APP_BACKEND_URI}/transaction/withdraw`;
        const token = Cookies.get("_lab__topup");

        let validId = this.props.availableBanks.find(
            (banks) => banks.code === data.bank_code
        );

        if (!validId) {
            return swalt("Withdrawal Failed", "Invalid Bank", "error");
        } else if (!data.account_number || data.account_number.length !== 10) {
            return swalt(
                "Withdrawal Failed",
                "Account number required",
                "error"
            );
        } else if (!data.name) {
            return swalt("Withdrawal Failed", "Account Not Verified", "error");
        }

        Swal.fire({
            title: "Withdraw Balance",
            text: "You won't be able to revert this!",
            html: `<div><p style="text-align: center">TO:-- <b>${data.name.toUpperCase()}</b></p>`,
            icon: "question",
            backdrop: "#00000090",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Withdraw",
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ waiting: true });
                axios
                    .post(api, data, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then((res) => {
                        this.props.getTransactionHistory();
                        if (!res.data.error) {
                            swalt(
                                "Withdrawal Successful",
                                "Thanks alot for being with us all long. We tried our best to be faithful! Thanks once again",
                                "success"
                            );
                            this.props.history.push("/dashboard");
                        } else {
                            swalt(
                                "Withdrawal Failed",
                                res.data.errorMsg
                                    ? `${res.data.errorMsg}`
                                    : "Error Completing Transaction, Contact Admin",
                                "warning"
                            );
                            this.setState({ waiting: false });
                        }
                    })
                    .catch((err) => {
                        this.props.getTransactionHistory();
                        swalt(
                            "Withdrawal Failed",
                            "Error  completing the transaction, Contact admin",
                            "error"
                        );
                        this.setState({ waiting: false });
                    });
            }
        });
    }

    render() {
        return (
            <Wrapper>
                <Helmet>
                    <title>TOP UP LAB | WITHDRAWAL</title>
                </Helmet>
                <form className={styles.Form} onSubmit={this.onSubmit}>
                    <h1>WITHDRAW BALANCE</h1>
                    <h3>As Low as ₦1</h3>
                    <div>
                        <label>Balance</label>
                        <input
                            onChange={this.onChange}
                            type="tel"
                            name="cardNumber"
                            id="cardNumber"
                            autoComplete="off"
                            placeholder="Smart Card number / IUC number*"
                            value={this.props.userInfo.balance}
                            required={true}
                            disabled={true}
                        />
                    </div>
                    <div>
                        <label>Bank Name</label>
                        <select
                            name="networkProvider"
                            id="networkProvider"
                            className={styles.networkProvider}
                            onChange={this.onChange}
                            required
                            disabled={
                                this.state.waiting || this.state.validated
                            }
                        >
                            <option value="" hidden>
                                Bank Name
                            </option>
                            {this.props.availableBanks?.map((bank, index) => {
                                return (
                                    <option value={bank.code} key={index}>
                                        {bank.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    <div>
                        <label>Account Number</label>
                        <input
                            onChange={this.onChange}
                            type="tel"
                            name="cardNumber"
                            id="cardNumber"
                            autoComplete="off"
                            placeholder="Account number*"
                            value={this.state.cardNumber}
                            required={true}
                            disabled={
                                this.state.waiting || this.state.validated
                            }
                        />
                    </div>
                    {this.state.validated ? (
                        <div>
                            <label>User</label>
                            <input
                                onChange={this.onChange}
                                type="tel"
                                name="cardUser"
                                id="cardUser"
                                autoComplete="off"
                                value={this.state.user}
                                required={true}
                                disabled={true}
                            />
                        </div>
                    ) : null}
                    {this.state.validated ? (
                        <button
                            type="submit"
                            disabled={
                                this.state.waiting ||
                                this.props.userInfo.balance < 1
                            }
                        >
                            {this.state.waiting ? <Spinner /> : "WITHDRAW"}
                        </button>
                    ) : (
                        <button
                            type="button"
                            onClick={this.validate}
                            disabled={this.state.validating}
                        >
                            {this.state.validating ? <Spinner /> : "VALIDATE"}
                        </button>
                    )}
                </form>
                <div className={styles.card}>
                    <b>
                        Kindly withdraw all your money, even if it's as Low as ₦1, please do. Anyone who failed to do so and has a balance greater than ₦50 before June 1st will get his or her money back as airtime, annyone with any amount below, the person's money will be used for donation. Thanks
                    </b>
                </div>
            </Wrapper>
        );
    }
}

Index.propsTypes = {
    getTransactionHistory: PropTypes.func.isRequired,
    tvSubscription: PropTypes.object.isRequired,
    availableBanks: PropTypes.object.isRequired,
    userInfo: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    userInfo: state.user.userInfo,
    tvSubscription: state.user.tvSubscription,
    availableBanks: state.user.availableBanks,
});

export default connect(mapStateToProps, { getTransactionHistory })(Index);
